export default __webpack_public_path__ + "static/summer_containers43-5196d87a62cb1f67b72eaa9c54ad8e3a.webp";